import React from 'react'
import TableMain from '../Common/table/TableMain'
import { getLastPage } from '../../utils/getLastPage';
import Alert from 'react-bootstrap/Alert';
import { useTranslation } from 'react-i18next';
function HoldingTankTable(props) {
  const headers = [
    "memberName",
    "username",
    "product",
    "price",
    "placement",
    "position",
    "regDate",
  ];
  const lastPage = getLastPage(props.itemsPerPage, props?.data?.totalCount);
  const { t } = useTranslation()
  return (
    <div className="ewallet_table_section">
      {
        props?.user&&
        !props?.user?.treeStatus &&
        <Alert variant="primary">
          <i class="fa-solid fa-circle-info fa-fade fa-xl"></i>{" "}{t('you_r_under_holding_tank')}
        </Alert>
      }

      <div className="ewallet_table_section_cnt" style={{ opacity: !props?.user?.treeStatus ? 0.5 : '',pointerEvents:!props?.user?.treeStatus ?'none':'' }}>
        <div className="table-responsive min-hieght-table">
          <TableMain
            headers={headers}
            data={props.data?.data}
            startPage={1}
            currentPage={props.currentPage}
            totalPages={lastPage}
            type={props.type}
            itemsPerPage={props.itemsPerPage}
            setItemsPerPage={props.setItemsPerPage}
            setCurrentPage={props.setCurrentPage}
            placementChangeHandler={props.placementChangeHandler}
            selectedPlacement={props.selectedPlacement}
            positionLoader={props.positionLoader}
            availiablePositions={props.availiablePositions}
            selectedRowIndex={props.selectedRowIndex}
            positionChangeHandler={props.positionChangeHandler}
            selectedPosition={props.selectedPosition}
            placeHoldingTankusers={props.placeHoldingTankusers}
            placeUserApiLoading={props.placeUserApiLoading}
            placementErr={props.placementErr}
            positionErr={props.positionErr}
          />
        </div>
      </div>
    </div>
  )
}

export default HoldingTankTable